<template>
    <div :class="['module-wrapper', storeCommon.inTopTab ? 'in-top-tab' : '']" ref="moduleWrapperRef">
        <!-- 底部弹窗：使用 h5-ui QPop position="bottom" -->
        <QPop
            v-model="showPop"
            class="module-card-pop"
            position="bottom"
            :closeIconTypes="['right-close']"
            :contentIsScroll="true"
            @close="closePop"
        >
            <div class="module-pop-content">
                <div class="module-bg">
                    <img :src="type === 1 ? voteImg : taskImg" alt="">
                    <div class="bg-fill"></div>
                </div>
                <div class="module-content">
                    <div class="module-content-title">{{ $props.subTitle }}</div>
                    <div
                        class="module-content-wrapper"
                        :style="{ maxHeight: `calc(70vh - ${storeCommon.inTopTab ? storeCommon.inTopTabNavHeight : 0}px)` }">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </QPop>
    </div>
</template>
<script lang="ts" setup>
import { QPop } from '@q-front-npm/h5-ui';
import { ref, watch } from 'vue';
import { useStore } from '@/store';
const store = useStore();
import voteImg from '@/assets/images/module/img_toupiao.png';
import taskImg from '@/assets/images/module/img_zhuan.png';
import { useStoreCommon } from '@common/store/common';
import { setWebviewPullRefresh } from '@q-front-npm/jsbridge';
const storeCommon = useStoreCommon();

const emit = defineEmits(['input', 'close']);
const props = defineProps({
    type: {
        type: Number,
        default: 1,
    },
    value: {
        type: Boolean,
        default: false,
    },
    subTitle: {
        type: String,
        default: '',
    },
});
const showPop = ref(props.value);
watch(() => props.value, (newVal) => {
    console.log('newVal', newVal);
    showPop.value = newVal;
    if (newVal && storeCommon.inTopTab) { setWebviewPullRefresh(false); }
}, { immediate: true, });

const closePop = () => {
    console.log('closePop');
    emit('close');
    emit('input', false);
    if (storeCommon.inTopTab) { setWebviewPullRefresh(true); }
};
</script>
<style lang="scss" scoped>
.module-wrapper {
    position: relative;
    .module-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        z-index: -1;
        img {
            width: 100%;
            height: auto;
        }
        .bg-fill {
            flex: 1;
            background-color: #f5f5f5;
        }
    }
    .module-content {
        padding: 154px 24px 64px;
        z-index: 10;
    }
    .module-content-title {
        font-size: 24px;
        color: #896B49;
        line-height: 34px;
        margin-left: 20px;
        margin-bottom: 40px;
    }
    :deep(.q-popup-content) {
        background-color: transparent;
    }
}

/* 底部弹窗内容样式（slot 内容在弹窗内，需覆盖弹窗默认样式） */
.module-card-pop {
    :deep(.q-popup-content) {
        border-radius: 40px 40px 0 0;
        // overflow: hidden;
    }
    :deep(.q-popup-header-right) {
       top: -24px;
    }
    :deep(.q-popup-header-close-icon) {
        color: #B3B3B3;
        font-size: 30px;
        width: 48px;
        height: 48px;
        border: 2px solid #B3B3B3;
        border-radius: 50%;
    }
    :deep(.q-popup-header-title) {
        font-size: 32px;
        color: #896B49;
        line-height: 48px;
    }
}

.module-pop-content {
    position: relative;
    // background-color: #fff;
    .module-bg-fill {
        display: none;
    }
}
.module-content-wrapper {
    overflow-y: auto;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        display: none;
    }
}
.in-top-tab {
    :deep(.q-popup-bottom) {
        bottom: -2px;
    }
}
</style>
<style lang="scss">
.module-card-pop {
    .q-scroll-view-control-touch {
        padding-bottom: 0!important;
    }
}
</style>
